<div class="container-fluid p-0">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <span class="navbar-brand">Maintenance Records</span>
    <button
      class="navbar-toggler"
      type="button" data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <span class="mr-auto">
        <button
          class="m-1 mr-2"
          type="button"
          color="primary"
          mat-raised-button
          (click)="onAdd()"
          *ngIf="canCreate"
          matTooltip="Click this button to create a new maintenance record.">
          <mat-icon>add</mat-icon>
          Add Record
        </button>

        <!-- The menu only holds Select All and the archive/restore actions, so the menu and its trigger
             are wrapped together in the delete guard. A mat-menu left outside the guard would still be
             rendered into the CDK overlay. -->
        <ng-container *ngIf="canDelete">
          <mat-menu #appMenu="matMenu">
            <button mat-menu-item (click)="dataSource.selectAllToggle()">
              <mat-icon *ngIf="dataSource.isAllSelected()"> clear_all</mat-icon><mat-icon *ngIf="!dataSource.isAllSelected()">select_all</mat-icon>
              {{ dataSource.isAllSelected() ? 'Deselect' : 'Select' }} All
            </button>
            <button *ngIf="dataSource.filters.archived == 'false'" mat-menu-item (click)="onRemoveSelected()" [disabled]="!dataSource.selection.hasValue()">
              <mat-icon>archive</mat-icon> Archive Selected
            </button>

            <button *ngIf="dataSource.filters.archived == 'true'" mat-menu-item (click)="onRestoreSelected()" [disabled]="!dataSource.selection.hasValue()">
              <mat-icon>restore</mat-icon> Restore Selected
            </button>
          </mat-menu>

          <button mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu" matTooltip="Use this menu to select/deselect Asset Maintenance Records." style="min-width: 120px">
            <mat-icon>more_vert</mat-icon>
            List Menu
          </button>
        </ng-container>
      </span>

      <button mat-raised-button class="m-1 mr-lg-3" (click)="onFilter()" *ngIf="canView" matTooltip="Click this button to display filter options.">
        <mat-icon>filter_list</mat-icon> Filter
      </button>

      <form class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)" *ngIf="canView">
        <input
          class="form-control ml-0 mr-2 my-1"
          type="search"
          [(ngModel)]="dataSource.search"
          name="search"
          placeholder="Search"
          aria-label="Search"
          id="search-input"
          matTooltip="Search for Maintenance Records."/>

        <button
          mat-raised-button
          color="secondary"
          type="submit"
          class="mx-0 my-1"
          id="search-button"
          matTooltip="Click this button to run the current search.">
          <mat-icon>search</mat-icon> Search
        </button>
      </form>

    </div>
  </nav>

  <div class="alert alert-warning m-2" *ngIf="!canView">
    <mat-icon class="align-middle mr-2">info</mat-icon>
    You do not have permission to view maintenance records.
  </div>

  <div class="mat-elevation-z8 scroll-box" *ngIf="canView">
    <mat-paginator #paginator1 [length]="dataSource?.total | async" [pageSize]="dataSource.limit" [pageSizeOptions]="dataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>

    <table mat-table [dataSource]="dataSource" matSort matSortActive="id" matSortDirection="asc" matSortDisableClear>

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
          <mat-checkbox
            (change)="$event ? dataSource.selectAllToggle() : null"
            [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
            [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()"
            matTooltip="Toggle select all records.">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let record">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? dataSource.selection.toggle(record.id) : null"
            [checked]="dataSource.selection.isSelected(record.id)"
            matTooltip="Toggle select this record.">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the id of the maintenance record.">
          #
        </th>
        <td mat-cell *matCellDef="let record">
          {{ record.id }}
        </td>
      </ng-container>

      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the maintenance record." [style.width.px]="250">
          Title
        </th>
        <td mat-cell *matCellDef="let record">
          {{ record.title }}
        </td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="200">
          Type
        </th>
        <td mat-cell *matCellDef="let record">
          {{ assetMaintenanceRecordsService.getTypeLabel(record.type) }}
          <ng-container *ngIf="assetMaintenanceRecordsService.isOtherType(record.type) && record.type_other">
            - {{ record.type_other }}
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>
          Status
        </th>
        <td mat-cell *matCellDef="let record">
          <span [style.color]="assetMaintenanceRecordsService.getStatusColor(record.status) || null">
            {{ assetMaintenanceRecordsService.getStatusLabel(record.status) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="priority">
        <th mat-header-cell *matHeaderCellDef>
          Priority
        </th>
        <td mat-cell *matCellDef="let record">
          <span [style.color]="assetMaintenanceRecordsService.getPriorityColor(record.priority) || null">
            {{ assetMaintenanceRecordsService.getPriorityLabel(record.priority) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="due_at">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the due date of the maintenance record.">
          Due Date
        </th>
        <td mat-cell *matCellDef="let record">
          <span [style.color]="utils.getDueDateColor(record.due_at) || null">
            {{ record.due_at ? ((record.due_at * 1000) | timezoneConvertMedium) : '' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="users">
        <th mat-header-cell *matHeaderCellDef class="no-padding">
          Assigned Users
        </th>
        <td mat-cell *matCellDef="let record" class="no-padding">
          <ng-container *ngIf="record?.users?.length">
            <span *ngFor="let user of record.users | slice:0:MAX_VISIBLE_ASSIGNED_USERS">
              <a (click)="onUserPublicView(user.hash)" matTooltip="View User Public Profile">
                {{ user.contact_person }}
              </a><br>
            </span>
            <span *ngIf="record.users.length > MAX_VISIBLE_ASSIGNED_USERS" [matTooltip]="getRemainingUsersTooltip(record.users)">
              {{ record.users.length - MAX_VISIBLE_ASSIGNED_USERS }} more users
            </span>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="date_created">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the date the maintenance record was added.">
          Created At
        </th>
        <td mat-cell *matCellDef="let record">
          {{ (record.date_created * 1000) | timezoneConvertMedium }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="240"></th>
        <td mat-cell *matCellDef="let record">
          <button *ngIf="canView && dataSource.filters.archived == 'false'" type="button" mat-button (click)="onView(record.id)">
            View
          </button>
          <button *ngIf="canEdit && dataSource.filters.archived == 'false'" type="button" mat-button (click)="onEdit(record)">
            Edit
          </button>
          <button *ngIf="canDelete && dataSource.filters.archived == 'false'" type="button" mat-button (click)="onRemove(record)">
            Archive
          </button>
          <button *ngIf="canDelete && dataSource.filters.archived == 'true'" type="button" mat-button (click)="onRestore(record.id)">
            Restore
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="listColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: listColumns"></tr>
    </table>

    <mat-paginator #paginator2 [length]="dataSource?.total | async" [pageSize]="dataSource.limit" [pageSizeOptions]="dataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>
  </div>
</div>
